// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__PGmlQ","link":"style_link__O0swf","merun":"style_merun__V7oTX","smallBtn":"style_smallBtn__ikF4c","btnLightWhite":"style_btnLightWhite__6Eovl"};